import { ClienteAfi } from '../cliente-afi';
import { Fondo } from '../fondo.entity';
import { Cuenta } from '../cuenta.entity';
import { Banco } from '../Banco/banco.entity';
import { CuentaBancaria } from '../Banco/cuenta.entity';
import { File } from '../../General/file.entity';
import { Moneda } from '../moneda.entity';

export class NotificacionAporte {
    numeroSolicitud?: string;
    fechaRegistro?: Date;
    tipoAporte?: string;
    nombreCliente?: string;
    identificacionCliente?: string;
    empresa?: ClienteAfi;
    fondo?: Fondo;
    nombreFondo?: string;
    cuenta?: Cuenta;
    numeroCuenta?: string;
    moneda?: Moneda;
    monedaAporte?: string;
    valorAporte?: number;
    fechaAporte?: Date;
    formaDeposito?: string;
    banco?: Banco;
    nombreBanco?: string;
    cuentaBancaria?: CuentaBancaria;
    cuentaBanco?: string;
    tipoCuentaBanco?: string;
    nombrePromotor?: string;
    numeroCheque?: string;
    comentarios?: string;

    archivosObjects?: File[];

    finished?: boolean;
}